export {default} from "./Agencia"

